import styled from '@emotion/styled';
// Theme 타입을 명시적으로 사용
const themed = (styles)=>(props)=>styles(props.theme);
export const FooterContainer = styled.div(themed((theme)=>`
  padding: ${theme.spacing.md};
  border-top: 1px solid ${theme.border};
  margin-top: auto; // 푸터를 하단에 고정 (TemplateContainer가 flex-direction: column이어야 함)
`));
export const LogoutButtonContainer = styled.div(themed((theme)=>`
  margin-bottom: ${theme.spacing.md};
`));
// 기본 Button을 스타일링하여 LogoutButton 생성
export const StyledLogoutButton = styled.button(themed((theme)=>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  border-radius: 0.375rem;
  
  // 테마 변수 사용 (theme.danger, theme.dangerText 등)
  background-color: ${theme.danger || '#dc3545'}; // 기본값 추가
  color: ${theme.dangerText || '#ffffff'}; // 기본값 추가
  width: 100%;
  padding: ${theme.spacing.sm} 0;

  &:hover {
    background-color: ${theme.dangerDark || '#c82333'}; // 기본값 추가
  }
  
  &:active {
    transform: scale(0.98);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`));
export const CopyrightContainer = styled.div(themed((theme)=>`
  padding: ${theme.spacing.sm};
  text-align: center;
`));
export const CopyrightText = styled.p(themed((theme)=>`
  font-size: ${theme.typography.fontSize.xs};
  color: ${theme.textMuted}; // 흐린 텍스트 색상 사용
`));
